module.exports = __webpack_public_path__ + "img/error.5706d718.svg";